/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, OnInit } from '@angular/core';
import { LoggerService } from '../../../../../modules/shared/services/logger.service';
import { MatDialog } from '@angular/material/dialog';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { ChangePasswordDialogComponent } from '../reset-password-dialog/change-password-dialog.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'dash-gis-reset-password-button',
    templateUrl: './reset-password-button.component.html',
    styleUrls: ['./reset-password-button.component.scss'],
    imports: [MatButton],
})
export class ResetPasswordButtonComponent implements OnInit {
    constructor(private logger: LoggerService, private dialog: MatDialog) {}

    ngOnInit(): void {}

    showResetForm() {
        this.dialog.open(ChangePasswordDialogComponent, { disableClose: true, width: '420px' });
    }
}
